import script from "./PatientPediatria.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientPediatria.vue?vue&type=script&setup=true&lang=js"

import "./PatientPediatria.vue?vue&type=style&index=0&id=1310b714&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1310b714"]])

export default __exports__